import { Link } from 'react-router-dom';
import { useState } from 'react';
import ModalContainer from '../../components/modalContainer';
import villeIcon from '../../assets/images/ville.svg';
import meetingIcon from '../../assets/images/meeting.svg';
import listsIcon from '../../assets/images/lists.svg';
import UserSettings from '../../assets/icons/userSetti.svg';
import './style.scss';
import ModalMeetingEdit from '../../components/modalMeetingsEdit';
import {saveMeetingGeneralInfo} from "../../API/apiService";
import {toast} from "react-toastify";

function AdminMenu() {
  // STATES //
  const [modalMeeting, setModalMeeting] = useState(false);

  async function handleAccept(meeting) {
    if (meeting) {
      const response = await saveMeetingGeneralInfo(meeting);
      if (response) {
        toast('Encuentros actualizados', {
          type: 'success'
        });
        setModalMeeting(false)
      } else {
        toast('Error actualizando ecuentro', {
          type: 'error'
        });
        setModalMeeting(false)
      }
    }
  }
  function handleCancel() {
    setModalMeeting(false)
  }
  return (
    <>
      {modalMeeting && (
        <ModalContainer>
          <ModalMeetingEdit handleAccept={handleAccept}  handleCancel={handleCancel}  />
        </ModalContainer>
      )}
      <section className='menuAdmin-main-container'>
        <div className='option-general-container'>
          <Link
            to={'/administrador/menu/escuelas'}
            className='option-container'>
            <div className='image-container'>
              <img src={villeIcon} alt='' />
            </div>
            <p className='description'>
              Crea y actualiza escuelas según comuna o dinamizador
            </p>
            <p className='title'>ESCUELAS</p>
          </Link>

          <div
            onClick={() => setModalMeeting(true)}
            className='option-container'>
            <div className='image-container'>
              <img src={meetingIcon} alt='' />
            </div>
            <p className='description'>
              Edita el número de encuentros y de eventos del año en vigencia
            </p>
            <p className='title'>ENCUENTROS</p>
          </div>
          <Link
            to={'/administrador/menu/asistencias'}
            className='option-container'>
            <div className='image-container'>
              <img src={listsIcon} alt='' />
            </div>
            <p className='description'>
              Verifica y guarda la asistencia de los beneficiarios a los
              encuentros programados.
            </p>
            <p className='title'>ASISTENCIAS</p>
          </Link>
          <Link
            to={'/administrador/menu/caracterizacion'}
            className='option-container'>
            <div className='image-container'>
              <img src={UserSettings} alt='' />
            </div>
            <p className='description'>
              Busca o ingresa nuevos usuarios a la plataforma
            </p>
            <p className='title'>CARACTERIZACIÓN</p>
          </Link>
        </div>
      </section>
    </>
  );
}

export default AdminMenu;
